/**
 * Ephemeral PR envs all share one RDS instance, and Prisma's default pool size
 * (num_physical_cpus * 2 + 1) is sized off the node's CPU count, not these pods'
 * tiny CPU requests — left unset, that exhausts the shared instance's max_connections
 * as more PRs are open concurrently.
 */
const EPHEMERAL_CONNECTION_LIMIT = 3;

/**
 * Builds the primary-DB connection URL, applying the `DATABASE_NAME` env var
 * (used by ephemeral PR envs for database-level isolation) when set.
 */
export function getPrimaryDatabaseUrl(): string {
  const baseUrl = process.env["PRIMARY_DATABASE_URL"];
  if (!baseUrl) {
    throw new Error("PRIMARY_DATABASE_URL is not set");
  }

  const dbName = process.env["DATABASE_NAME"];
  if (!dbName) {
    return baseUrl;
  }

  const url = new URL(baseUrl);
  url.pathname = `/${dbName}`;
  url.searchParams.set("connection_limit", String(EPHEMERAL_CONNECTION_LIMIT));
  return url.toString();
}
